var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-relative",
      class: {
        "object-container-automation": !_vm.onProperties,
        "object-active":
          _vm.blockActive ||
          (!_vm.onProperties && _vm.id === _vm.propertiesIDBlock),
        "object-disabled": !_vm.onProperties && _vm.isDisableBlock
      },
      staticStyle: { cursor: "default" },
      attrs: { id: "vp-action" },
      on: { mouseover: _vm.pauseZoom, mouseleave: _vm.resumeZoom }
    },
    [
      _vm.onProperties
        ? _c(
            "div",
            {
              staticClass: "toggle-disable-block",
              style: [!_vm.data_action.object ? { top: "-33px" } : ""]
            },
            [
              _c("j-switch", {
                model: {
                  value: _vm.disable_block,
                  callback: function($$v) {
                    _vm.disable_block = $$v
                  },
                  expression: "disable_block"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-toggle-disable" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.disable_block ? "Disable" : "Enable") +
                    " this block\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? [
            _c("img", {
              staticClass: "icon-drag",
              attrs: { src: require("@/assets/new-form-ui/dragged.svg") }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "m__r--5",
              attrs: {
                src: require("@/assets/automation/action-lg.png"),
                width: "22"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "title-automation m__r--5" }, [
              _vm._v("ACTION")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "id-block-automation" }, [
              _vm._v(_vm._s(_vm.dataEdit ? "#" + _vm.dataEdit.id : ""))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? _c("img", {
            staticClass: "pull-right cursor-pointer",
            attrs: {
              src: require("@/assets/automation/config.svg"),
              width: "20",
              height: "20"
            },
            on: { click: _vm.showProperties }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties &&
      _vm.dataEdit &&
      (_vm.objectType === "function" ||
        _vm.objectType === "job" ||
        _vm.objectType === "dedicated_job")
        ? _c("img", {
            staticClass: "pull-right cursor-pointer m__r--5",
            attrs: {
              src: require("@/assets/automation/open-tab.svg"),
              width: "20",
              height: "20"
            },
            on: { click: _vm.openTabVP }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.onProperties,
              expression: "onProperties"
            }
          ]
        },
        [
          !_vm.data_action.object
            ? _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.data_action.object.$error } },
                [
                  _c("label", [_vm._v(" Object ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      "error-required": _vm.$v.data_action.object.$error,
                      options: _vm.objectOptionsFiltered,
                      placeholder: "Object"
                    },
                    on: { getData: _vm.objectSelected },
                    model: {
                      value: _vm.$v.data_action.object.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.data_action.object, "$model", $$v)
                      },
                      expression: "$v.data_action.object.$model"
                    }
                  })
                ],
                1
              )
            : _c("div", { staticClass: "sub-header-properties-wrap" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/automation/" +
                      _vm.selectedObject.img +
                      ".svg"),
                    width: "25"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-object" }, [
                  _vm._v(" " + _vm._s(_vm.selectedObject.title) + " ")
                ])
              ]),
          _vm._v(" "),
          _vm.data_action.object === "form"
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.table_group.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Table Group ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.data_action.table_group.$error,
                                  options: _vm.tableGroupOptions,
                                  placeholder: "Select Table Group",
                                  "value-format": "object",
                                  label: "name"
                                },
                                model: {
                                  value: _vm.$v.data_action.table_group.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.table_group,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.data_action.table_group.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.form.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Table ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.data_action.form.$error,
                                  disabled: !_vm.data_action.table_group,
                                  options: _vm.tableOptions,
                                  placeholder: "Select Table",
                                  "value-format": "object",
                                  label: "name"
                                },
                                model: {
                                  value: _vm.$v.data_action.form.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.form,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.form.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.do.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Do ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.data_action.do.$error,
                                  options: _vm.doOptions,
                                  placeholder: "Do"
                                },
                                model: {
                                  value: _vm.$v.data_action.do.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.do,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.do.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_action.do === "find_record" ||
                  _vm.data_action.do === "find_records" ||
                  _vm.data_action.do === "update_record"
                    ? _c("div", [
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "swithcer-filter m__r--8",
                                  class: { active: _vm.versionFilter === "v1" },
                                  on: {
                                    click: function($event) {
                                      _vm.versionFilter = "v1"
                                    }
                                  }
                                },
                                [_vm._v("\n              V1\n            ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "swithcer-filter",
                                  class: { active: _vm.versionFilter === "v2" },
                                  on: {
                                    click: function($event) {
                                      _vm.versionFilter = "v2"
                                    }
                                  }
                                },
                                [_vm._v("\n              V2\n            ")]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.versionFilter === "v2"
                          ? _c(
                              "div",
                              {
                                staticClass: "conditions-wrap",
                                class: {
                                  "error-input":
                                    _vm.$v.data_action.conditions.$error
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "conditions-left",
                                    class: {
                                      "show-vertical-line":
                                        _vm.data_action.conditions &&
                                        _vm.data_action.conditions.length > 1,
                                      "hide-vertical-line":
                                        _vm.data_action.conditions &&
                                        _vm.data_action.conditions.length === 1
                                    }
                                  },
                                  [
                                    _vm.data_action.conditions &&
                                    _vm.data_action.conditions.length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "conditions-vertical-line"
                                          },
                                          [
                                            _c("div"),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "v-line-top v-line"
                                            }),
                                            _vm._v(" "),
                                            _c("div")
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "conditions-operator" },
                                      [_vm._v("AND")]
                                    ),
                                    _vm._v(" "),
                                    _vm.data_action.conditions &&
                                    _vm.data_action.conditions.length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "conditions-vertical-line"
                                          },
                                          [
                                            _c("div"),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "v-line-bottom v-line"
                                            }),
                                            _vm._v(" "),
                                            _c("div")
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "conditions-right" }, [
                                  _vm.data_action.conditions &&
                                  _vm.data_action.conditions.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "mb-2" },
                                        _vm._l(
                                          _vm.data_action.conditions,
                                          function(item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "conditions-item-wrap",
                                                class: {
                                                  selected:
                                                    index ===
                                                    _vm.selectedIndexCondition
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "field-item" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.field) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "operator-item"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.operator
                                                            ? item.operator.replaceAll(
                                                                "_",
                                                                " "
                                                              )
                                                            : ""
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.operator !== "between"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "value-item"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.value
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "value-item"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              item.value[0]
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-arrow-right mx-3"
                                                        }),
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              item.value[1]
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "edit-or-delete"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "button" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "edit d-flex",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.openModalCondition(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-pencil-square-o"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "delete",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.deleteConditions(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-trash"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add-conditions",
                                      on: {
                                        click: function($event) {
                                          _vm.openModalCondition()
                                        }
                                      }
                                    },
                                    [_vm._v("+ Add Filter\n            ")]
                                  )
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              [
                                _vm._l(
                                  _vm.$v.data_action.conditions.$each.$iter,
                                  function(item, index) {
                                    return _c(
                                      "b-row",
                                      { key: index },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "p__r--3",
                                            attrs: { md: "5" }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                class: {
                                                  "error-input":
                                                    item.field.$error
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(" Field ")
                                                ]),
                                                _vm._v(" "),
                                                _c("j-single-select", {
                                                  attrs: {
                                                    "error-required":
                                                      item.field.$error,
                                                    options: _vm.list_field,
                                                    label: "name",
                                                    placeholder: "Field"
                                                  },
                                                  model: {
                                                    value: item.field.$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item.field,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.field.$model"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "p__r--3 p__l--3",
                                            attrs: { md: "2" }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                class: {
                                                  "error-input":
                                                    item.operator.$error
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(" Operator ")
                                                ]),
                                                _vm._v(" "),
                                                _c("j-input", {
                                                  attrs: {
                                                    "error-required": false,
                                                    disabled: true,
                                                    value: "Is"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "p__r--3 p__l--3",
                                            attrs: { md: "4" }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                class: {
                                                  "error-input":
                                                    item.value.$error
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(" Value ")
                                                ]),
                                                _vm._v(" "),
                                                _c("j-input", {
                                                  attrs: {
                                                    "error-required":
                                                      item.value.$error,
                                                    "max-length": 255,
                                                    placeholder: "Value"
                                                  },
                                                  model: {
                                                    value: item.value.$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item.value,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.value.$model"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "cursor-pointer p__l--5",
                                            attrs: { md: "1" }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-lg fa-trash m__t--35",
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteConditions(index)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", { attrs: { md: "12" } }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn float-right btn-add-additional-info",
                                          on: { click: _vm.addConditions }
                                        },
                                        [
                                          _vm._v(
                                            "\n                + Add Conditions\n              "
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "delete_record"
                    ? _c(
                        "div",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-automation" }, [
                            _vm._v("Conditions")
                          ]),
                          _vm._v(" "),
                          _c("small", [_vm._v('"Where"')]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.$v.data_action.conditions.$each.$iter,
                            function(item, index) {
                              return _c(
                                "b-row",
                                { key: index },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__r--3",
                                      attrs: { md: "5" }
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          class: {
                                            "error-input": item.field.$error
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v(" Field ")]),
                                          _vm._v(" "),
                                          _c("j-single-select", {
                                            attrs: {
                                              "error-required":
                                                item.field.$error,
                                              options: _vm.list_field,
                                              label: "name",
                                              placeholder: "Field"
                                            },
                                            model: {
                                              value: item.field.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item.field,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression: "item.field.$model"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__r--3 p__l--3",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          class: {
                                            "error-input": item.operator.$error
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v(" Operator ")]),
                                          _vm._v(" "),
                                          _c("j-single-select", {
                                            attrs: {
                                              "error-required":
                                                item.operator.$error,
                                              options: _vm.operatorOptions
                                            },
                                            model: {
                                              value: item.operator.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item.operator,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression: "item.operator.$model"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__r--3 p__l--3",
                                      attrs: { md: "4" }
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          class: {
                                            "error-input": item.value.$error
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v(" Value ")]),
                                          _vm._v(" "),
                                          _c("j-input", {
                                            attrs: {
                                              "error-required":
                                                item.value.$error,
                                              "max-length": 255,
                                              placeholder: "Value"
                                            },
                                            model: {
                                              value: item.value.$model,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item.value,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression: "item.value.$model"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "cursor-pointer p__l--5",
                                      attrs: { md: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-lg fa-trash m__t--35",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteConditions(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { md: "12" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn float-right btn-add-additional-info",
                                    on: { click: _vm.addConditions }
                                  },
                                  [
                                    _vm._v(
                                      "\n              + Add Conditions\n            "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "find_records"
                    ? _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.sorting.key.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Sort By ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.sorting.key
                                              .$error,
                                          options: _vm.list_field,
                                          placeholder: "Sort by",
                                          "value-format": "object",
                                          label: "name"
                                        },
                                        model: {
                                          value: _vm.data_action.sorting.key,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.sorting,
                                              "key",
                                              $$v
                                            )
                                          },
                                          expression: "data_action.sorting.key"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.sorting.order
                                            .$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Order By ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.sorting.order
                                              .$error,
                                          options: _vm.orderOptions,
                                          placeholder: "Order by",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: _vm.data_action.sorting.order,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.sorting,
                                              "order",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.sorting.order"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.page.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Page ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.page.$error,
                                          placeholder: "Page"
                                        },
                                        model: {
                                          value: _vm.data_action.page,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action,
                                              "page",
                                              $$v
                                            )
                                          },
                                          expression: "data_action.page"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.limit.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Limit ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.limit.$error,
                                          placeholder: "Limit"
                                        },
                                        model: {
                                          value: _vm.data_action.limit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action,
                                              "limit",
                                              $$v
                                            )
                                          },
                                          expression: "data_action.limit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "create_record" ||
                  _vm.data_action.do === "update_record"
                    ? _c(
                        "div",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-automation" }, [
                            _vm._v("List Fields")
                          ]),
                          _vm._v(" "),
                          _vm.showBase
                            ? _c("j-form-record", {
                                ref: "jFormCreate",
                                attrs: {
                                  "data-fields": _vm.dataFields,
                                  "is-detail": _vm.dataEdit ? true : false
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "create_records"
                    ? _c(
                        "div",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-automation" }, [
                            _vm._v("Data Input")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.input.$error
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "8" } }, [
                                    _c("label", [_vm._v(" Body ")])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { md: "4" } }, [
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "title-example-input-joana-create-records",
                                        on: {
                                          click: function($event) {
                                            _vm.toggleModalExample(true)
                                          }
                                        }
                                      },
                                      [_vm._v("Example")]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("prism-editor", {
                                staticClass: "my-editor-block-joana",
                                class: { "dark-mode": _vm.darkMode },
                                attrs: {
                                  highlight: _vm.highlighter,
                                  "line-numbers": true
                                },
                                model: {
                                  value: _vm.$v.data_action.input.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.input,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.input.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "call_webhook"
            ? _c(
                "div",
                [
                  _c("span", { staticClass: "title-automation" }, [
                    _vm._v("Endpoint")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.method.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Method ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.data_action.method.$error,
                                  options: _vm.methodOptions,
                                  placeholder: "Select"
                                },
                                model: {
                                  value: _vm.$v.data_action.method.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.method,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.method.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "8" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.url.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Url ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { "max-length": 255 },
                                model: {
                                  value: _vm.$v.data_action.url.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.url,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.url.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("span", { staticClass: "title-automation" }, [
                          _vm._v("Header")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _vm._l(_vm.data_action.column, function(data, index) {
                            return _c(
                              "div",
                              { key: index + 0, staticClass: "list-column-ui" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center cursor-pointer m__l--16"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-lg fa-ellipsis-v "
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "5" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c("label", [_vm._v(" Name ")]),
                                            _vm._v(" "),
                                            _c("j-input", {
                                              attrs: {
                                                placeholder: "Enter column name"
                                              },
                                              model: {
                                                value: data.name,
                                                callback: function($$v) {
                                                  _vm.$set(data, "name", $$v)
                                                },
                                                expression: "data.name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "5" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c("label", [_vm._v(" Value ")]),
                                            _vm._v(" "),
                                            _c("j-input", {
                                              attrs: {
                                                placeholder:
                                                  "Enter column value"
                                              },
                                              model: {
                                                value: data.value,
                                                callback: function($$v) {
                                                  _vm.$set(data, "value", $$v)
                                                },
                                                expression: "data.value"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-center cursor-pointer m__l--1"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-lg fa-trash",
                                          on: {
                                            click: function($event) {
                                              _vm.deleteColumn(index)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-add-column",
                                    on: { click: _vm.addColumn }
                                  },
                                  [
                                    _vm._v(
                                      "\n                + Add Header\n              "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_action.method === "post" ||
                  _vm.data_action.method === "delete"
                    ? _c(
                        "div",
                        [
                          _c("span", { staticClass: "title-automation" }, [
                            _vm._v("Payload")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.body.$error
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "8" } }, [
                                    _c("label", [_vm._v(" Body ")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__r--1",
                                      attrs: { md: "3" }
                                    },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "pull-right" },
                                        [_vm._v("Dark Mode")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__l--1",
                                      attrs: { md: "1" }
                                    },
                                    [
                                      _c("j-toggle", {
                                        model: {
                                          value: _vm.darkMode,
                                          callback: function($$v) {
                                            _vm.darkMode = $$v
                                          },
                                          expression: "darkMode"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("prism-editor", {
                                staticClass: "my-editor",
                                class: { "dark-mode": _vm.darkMode },
                                attrs: {
                                  highlight: _vm.highlighter,
                                  "line-numbers": true
                                },
                                model: {
                                  value: _vm.$v.data_action.body.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.body,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.body.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "send_notification"
            ? _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_action.type.$error }
                    },
                    [
                      _c("label", [_vm._v(" Type ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required": _vm.$v.data_action.type.$error,
                          options: _vm.typeNotifOptions,
                          placeholder: "Type"
                        },
                        model: {
                          value: _vm.$v.data_action.type.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_action.type, "$model", $$v)
                          },
                          expression: "$v.data_action.type.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_action.type === "send_email"
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input": _vm.$v.data_action.to_email.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" To ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.to_email.$error,
                              placeholder: "To",
                              "max-length": 255,
                              label: "name"
                            },
                            model: {
                              value: _vm.$v.data_action.to_email.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.to_email,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_action.to_email.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_email"
                    ? _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" CC ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              placeholder: "CC",
                              "max-length": 255,
                              label: "name"
                            },
                            model: {
                              value: _vm.data_action.cc,
                              callback: function($$v) {
                                _vm.$set(_vm.data_action, "cc", $$v)
                              },
                              expression: "data_action.cc"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_email"
                    ? _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" BCC ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              placeholder: "BCC",
                              "max-length": 255,
                              label: "name"
                            },
                            model: {
                              value: _vm.data_action.bcc,
                              callback: function($$v) {
                                _vm.$set(_vm.data_action, "bcc", $$v)
                              },
                              expression: "data_action.bcc"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_notification"
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_action.push_notif_to.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" To ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.push_notif_to.$error,
                              placeholder: "To",
                              "value-format": "object",
                              label: "name"
                            },
                            model: {
                              value: _vm.$v.data_action.push_notif_to.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.push_notif_to,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_action.push_notif_to.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_email"
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input": _vm.$v.data_action.subject.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Subject ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.subject.$error,
                              "max-length": 255,
                              placeholder: "Subject"
                            },
                            model: {
                              value: _vm.$v.data_action.subject.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.subject,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_action.subject.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_email"
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input": _vm.$v.data_action.message.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Body ")]),
                          _vm._v(" "),
                          _c("quill-editor", {
                            ref: "myQuillEditor",
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.message.$error,
                              options: _vm.editorOption
                            },
                            model: {
                              value: _vm.$v.data_action.message.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.message,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_action.message.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_notification"
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_action.push_notif_heading.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Heading ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.push_notif_heading.$error,
                              "max-length": 255,
                              placeholder: "Heading"
                            },
                            model: {
                              value:
                                _vm.$v.data_action.push_notif_heading.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.push_notif_heading,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.data_action.push_notif_heading.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_notification"
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_action.push_notif_content.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Content ")]),
                          _vm._v(" "),
                          _c("j-textarea", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.push_notif_content.$error,
                              "max-length": 300
                            },
                            model: {
                              value:
                                _vm.$v.data_action.push_notif_content.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.push_notif_content,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.data_action.push_notif_content.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.type === "send_notification"
                    ? _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Custom Redirect ")]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            model: {
                              value: _vm.data_action.is_custom_redirect,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_action,
                                  "is_custom_redirect",
                                  $$v
                                )
                              },
                              expression: "data_action.is_custom_redirect"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.is_custom_redirect
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_action.script_redirect.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Script Redirect ")]),
                          _vm._v(" "),
                          _c("j-monaco-editor", {
                            ref: "scriptEditor",
                            attrs: { value: _vm.data_action.script_redirect }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.is_custom_redirect
                    ? _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_action.variable_redirect.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Variable Redirect ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_action.variable_redirect.$error,
                              "max-length": 255,
                              placeholder: "Variable Redirect"
                            },
                            model: {
                              value:
                                _vm.$v.data_action.variable_redirect.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_action.variable_redirect,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.data_action.variable_redirect.$model"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "data_connectivity"
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.connection.$error
                              }
                            },
                            [
                              _c(
                                "b-popover",
                                {
                                  ref: "popoverJDCBlockRef-" + _vm.dataIndex,
                                  attrs: {
                                    show: _vm.popOverJDCShow,
                                    target: "popoverJDCBlock-" + _vm.dataIndex,
                                    container: "vp-action",
                                    triggers: "hover focus",
                                    placement: "bottom"
                                  },
                                  on: {
                                    "update:show": function($event) {
                                      _vm.popOverJDCShow = $event
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "popoverJDC" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.dataConnectionDescription) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(" Connection "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.data_action.connection != null,
                                      expression:
                                        "data_action.connection != null "
                                    }
                                  ],
                                  staticClass: "fa fa-info-circle",
                                  attrs: {
                                    id: "popoverJDCBlock-" + _vm.dataIndex
                                  },
                                  on: { click: _vm.popOverJDCHandler }
                                })
                              ]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.data_action.connection.$error,
                                  options: _vm.loadOptionsDataConnectivity,
                                  "value-format": "object",
                                  placeholder: "Type"
                                },
                                on: {
                                  getData: function($event) {
                                    _vm.onChangeConnectionJDC(
                                      _vm.data_action.connection
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.$v.data_action.connection.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.connection,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.connection.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.do_jdc.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Do ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.data_action.do_jdc.$error,
                                  options: _vm.doOptionsDataConnectivity,
                                  placeholder: "Do"
                                },
                                model: {
                                  value: _vm.$v.data_action.do_jdc.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.do_jdc,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.do_jdc.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.query.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Query ")]),
                              _vm._v(" "),
                              _c("prism-editor", {
                                staticClass: "my-editor",
                                class: { "dark-mode": _vm.darkMode },
                                attrs: {
                                  highlight: _vm.highlighter,
                                  "line-numbers": true
                                },
                                model: {
                                  value: _vm.$v.data_action.query.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.query,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.query.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "function"
            ? _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_action.function_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Function Name ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required":
                            _vm.$v.data_action.function_name.$error,
                          options: _vm.listFunction,
                          placeholder: "Select Function Name",
                          label: "name"
                        },
                        model: {
                          value: _vm.$v.data_action.function_name.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.data_action.function_name,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.data_action.function_name.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v(" Description ")]),
                      _vm._v(" "),
                      _c("j-textarea", {
                        attrs: {
                          "error-required": false,
                          "max-length": 250,
                          disabled: true
                        },
                        model: {
                          value: _vm.actionDescription,
                          callback: function($$v) {
                            _vm.actionDescription = $$v
                          },
                          expression: "actionDescription"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_action.input.$error }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "m__t--10" },
                        [
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("label", [_vm._v(" Body ")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__r--1", attrs: { md: "3" } },
                            [
                              _c("small", { staticClass: "pull-right" }, [
                                _vm._v("Dark Mode")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "1" } },
                            [
                              _c("j-toggle", {
                                model: {
                                  value: _vm.darkMode,
                                  callback: function($$v) {
                                    _vm.darkMode = $$v
                                  },
                                  expression: "darkMode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("prism-editor", {
                        staticClass: "my-editor",
                        class: { "dark-mode": _vm.darkMode },
                        attrs: {
                          highlight: _vm.highlighter,
                          "line-numbers": true
                        },
                        model: {
                          value: _vm.$v.data_action.input.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_action.input, "$model", $$v)
                          },
                          expression: "$v.data_action.input.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "job"
            ? _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_action.job_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Job Name ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required": _vm.$v.data_action.job_name.$error,
                          options: _vm.listJob,
                          placeholder: "Select Job Name",
                          label: "name"
                        },
                        model: {
                          value: _vm.$v.data_action.job_name.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_action.job_name, "$model", $$v)
                          },
                          expression: "$v.data_action.job_name.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v(" Description ")]),
                      _vm._v(" "),
                      _c("j-textarea", {
                        attrs: {
                          "error-required": false,
                          "max-length": 250,
                          disabled: true
                        },
                        model: {
                          value: _vm.actionDescription,
                          callback: function($$v) {
                            _vm.actionDescription = $$v
                          },
                          expression: "actionDescription"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_action.input.$error }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "m__t--10" },
                        [
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("label", [_vm._v(" Body ")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__r--1", attrs: { md: "3" } },
                            [
                              _c("small", { staticClass: "pull-right" }, [
                                _vm._v("Dark Mode")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "1" } },
                            [
                              _c("j-toggle", {
                                model: {
                                  value: _vm.darkMode,
                                  callback: function($$v) {
                                    _vm.darkMode = $$v
                                  },
                                  expression: "darkMode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("prism-editor", {
                        staticClass: "my-editor",
                        class: { "dark-mode": _vm.darkMode },
                        attrs: {
                          highlight: _vm.highlighter,
                          "line-numbers": true
                        },
                        model: {
                          value: _vm.$v.data_action.input.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_action.input, "$model", $$v)
                          },
                          expression: "$v.data_action.input.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "warning-function-vp d-flex align-items-center"
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/warning.svg"),
                          alt: "warning"
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "dedicated_job"
            ? _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input":
                          _vm.$v.data_action.dedicated_job_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Dedicated Job Name ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required":
                            _vm.$v.data_action.dedicated_job_name.$error,
                          options: _vm.listDedicatedJob,
                          placeholder: "Select Dedicated Job Name",
                          label: "name"
                        },
                        model: {
                          value: _vm.$v.data_action.dedicated_job_name.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.data_action.dedicated_job_name,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.data_action.dedicated_job_name.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v(" Description ")]),
                      _vm._v(" "),
                      _c("j-textarea", {
                        attrs: {
                          "error-required": false,
                          "max-length": 250,
                          disabled: true
                        },
                        model: {
                          value: _vm.actionDescription,
                          callback: function($$v) {
                            _vm.actionDescription = $$v
                          },
                          expression: "actionDescription"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_action.input.$error }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "m__t--10" },
                        [
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("label", [_vm._v(" Body ")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__r--1", attrs: { md: "3" } },
                            [
                              _c("small", { staticClass: "pull-right" }, [
                                _vm._v("Dark Mode")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "1" } },
                            [
                              _c("j-toggle", {
                                model: {
                                  value: _vm.darkMode,
                                  callback: function($$v) {
                                    _vm.darkMode = $$v
                                  },
                                  expression: "darkMode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("prism-editor", {
                        staticClass: "my-editor",
                        class: { "dark-mode": _vm.darkMode },
                        attrs: {
                          highlight: _vm.highlighter,
                          "line-numbers": true
                        },
                        model: {
                          value: _vm.$v.data_action.input.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_action.input, "$model", $$v)
                          },
                          expression: "$v.data_action.input.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "warning-function-vp d-flex align-items-center"
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/warning.svg"),
                          alt: "warning"
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(2)
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "joana"
            ? _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_action.joana.group.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Dataset Group ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required":
                            _vm.$v.data_action.joana.group.$error,
                          options: _vm.datasetGroupOptions,
                          placeholder: "Select Dataset Group",
                          "value-format": "object",
                          label: "name"
                        },
                        model: {
                          value: _vm.$v.data_action.joana.group.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.data_action.joana.group,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.data_action.joana.group.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_action.joana.dataset.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Dataset ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required":
                            _vm.$v.data_action.joana.dataset.$error,
                          disabled: !_vm.data_action.joana.group,
                          options: _vm.datasetOptions,
                          placeholder: "Select Dataset",
                          "value-format": "object",
                          label: "name"
                        },
                        model: {
                          value: _vm.$v.data_action.joana.dataset.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.data_action.joana.dataset,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.data_action.joana.dataset.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { class: { "error-input": _vm.$v.data_action.do.$error } },
                    [
                      _c("label", [_vm._v(" Do ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required": _vm.$v.data_action.do.$error,
                          disabled: !_vm.data_action.joana.dataset,
                          options: _vm.doOptionsJoana,
                          placeholder: "Do"
                        },
                        model: {
                          value: _vm.$v.data_action.do.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_action.do, "$model", $$v)
                          },
                          expression: "$v.data_action.do.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_action.do === "execute_query"
                    ? _c(
                        "div",
                        { staticClass: "dataset-page-query-container" },
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-grey-query",
                              on: { click: _vm.openListQuery }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/icon/query/open.svg"),
                                  width: "13"
                                }
                              }),
                              _vm._v("\n          Open Saved Query\n        ")
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", { staticClass: "label-action-block" }, [
                              _vm._v("Query Box")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-query-type",
                                class: {
                                  "action-query-type-active":
                                    _vm.query_type === "sql"
                                },
                                staticStyle: { "margin-left": "315px" },
                                on: {
                                  click: function($event) {
                                    _vm.changeQueryType("sql")
                                  }
                                }
                              },
                              [_vm._v("SQL")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-query-type",
                                class: {
                                  "action-query-type-active":
                                    _vm.query_type === "mongodb"
                                },
                                staticStyle: { "margin-left": "10px" },
                                on: {
                                  click: function($event) {
                                    _vm.changeQueryType("mongodb")
                                  }
                                }
                              },
                              [_vm._v("MongoDB")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("j-monaco-editor", {
                            ref: "queryEditor",
                            attrs: {
                              value: _vm.dataQuery,
                              language:
                                _vm.query_type === "mongodb" ? "json" : "sql",
                              "disable-validate-json": true
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "warning-function-vp d-flex align-items-center m__t--15"
                            },
                            [
                              _c("img", {
                                staticStyle: { "margin-top": "-59px" },
                                attrs: {
                                  src: require("@/assets/icon/warning.svg"),
                                  alt: "warning"
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(3)
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "update_record" ||
                  _vm.data_action.do === "find_record" ||
                  _vm.data_action.do === "find_records"
                    ? _c("div", [
                        _c("hr"),
                        _vm._v(" "),
                        _c("span", { staticClass: "title-automation" }, [
                          _vm._v("Conditions")
                        ]),
                        _vm._v(" "),
                        _c("small", [_vm._v('"Where"')]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "conditions-wrap",
                            class: {
                              "error-input":
                                _vm.$v.data_action.conditions.$error
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "conditions-left",
                                class: {
                                  "show-vertical-line":
                                    _vm.data_action.conditions &&
                                    _vm.data_action.conditions.length > 1,
                                  "hide-vertical-line":
                                    _vm.data_action.conditions &&
                                    _vm.data_action.conditions.length === 1
                                }
                              },
                              [
                                _vm.data_action.conditions &&
                                _vm.data_action.conditions.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "conditions-vertical-line"
                                      },
                                      [
                                        _c("div"),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "v-line-top v-line"
                                        }),
                                        _vm._v(" "),
                                        _c("div")
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "conditions-operator" },
                                  [_vm._v("AND")]
                                ),
                                _vm._v(" "),
                                _vm.data_action.conditions &&
                                _vm.data_action.conditions.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "conditions-vertical-line"
                                      },
                                      [
                                        _c("div"),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "v-line-bottom v-line"
                                        }),
                                        _vm._v(" "),
                                        _c("div")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "conditions-right" }, [
                              _vm.data_action.conditions &&
                              _vm.data_action.conditions.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    _vm._l(_vm.data_action.conditions, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "conditions-item-wrap",
                                          class: {
                                            selected:
                                              index ===
                                              _vm.selectedIndexCondition
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "field-item" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.field) + " "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "operator-item" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.operator
                                                      ? item.operator ===
                                                        "is_not_like"
                                                        ? "not like"
                                                        : item.operator.replaceAll(
                                                            "_",
                                                            " "
                                                          )
                                                      : ""
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          item.operator !== "between"
                                            ? _c(
                                                "div",
                                                { staticClass: "value-item" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.value) +
                                                        " "
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                { staticClass: "value-item" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(item.value[0]) +
                                                      "\n                  "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-arrow-right mx-3"
                                                  }),
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(item.value[1]) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "edit-or-delete" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "button" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "edit d-flex",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.openModalCondition(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-pencil-square-o"
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.deleteConditions(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    })
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "add-conditions",
                                  on: {
                                    click: function($event) {
                                      _vm.openModalCondition()
                                    }
                                  }
                                },
                                [_vm._v("+ Add Filter")]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "find_records"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.sorting.key.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Sort By ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.sorting.key
                                              .$error,
                                          options: _vm.list_field,
                                          placeholder: "Sort by",
                                          "value-format": "object",
                                          label: "name"
                                        },
                                        model: {
                                          value: _vm.data_action.sorting.key,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.sorting,
                                              "key",
                                              $$v
                                            )
                                          },
                                          expression: "data_action.sorting.key"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.sorting.order
                                            .$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Order By ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.sorting.order
                                              .$error,
                                          options: _vm.orderOptions,
                                          placeholder: "Order by",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: _vm.data_action.sorting.order,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.sorting,
                                              "order",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.sorting.order"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.page.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Page ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.page.$error,
                                          placeholder: "Page"
                                        },
                                        model: {
                                          value: _vm.data_action.page,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action,
                                              "page",
                                              $$v
                                            )
                                          },
                                          expression: "data_action.page"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.limit.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Limit ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_action.limit.$error,
                                          placeholder: "Limit"
                                        },
                                        model: {
                                          value: _vm.data_action.limit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action,
                                              "limit",
                                              $$v
                                            )
                                          },
                                          expression: "data_action.limit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "create_record" ||
                  _vm.data_action.do === "update_record"
                    ? _c(
                        "div",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-automation" }, [
                            _vm._v("List Fields")
                          ]),
                          _vm._v(" "),
                          _vm.showBase
                            ? _c("j-form-record", {
                                ref: "jFormCreate",
                                attrs: {
                                  "data-fields": _vm.dataFields,
                                  "is-detail": _vm.dataEdit ? true : false
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.do === "create_records"
                    ? _c(
                        "div",
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-automation" }, [
                            _vm._v("Data Input")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_action.input.$error
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "8" } }, [
                                    _c("label", [_vm._v(" Body ")])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { md: "4" } }, [
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "title-example-input-joana-create-records",
                                        on: {
                                          click: function($event) {
                                            _vm.toggleModalExample(true)
                                          }
                                        }
                                      },
                                      [_vm._v("Example")]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("prism-editor", {
                                staticClass: "my-editor-block-joana",
                                class: { "dark-mode": _vm.darkMode },
                                attrs: {
                                  highlight: _vm.highlighter,
                                  "line-numbers": true
                                },
                                model: {
                                  value: _vm.$v.data_action.input.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_action.input,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_action.input.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "generate_file"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "section-border mb-3" },
                  [
                    _c("p", { staticClass: "title-section" }, [
                      _vm._v("File Properties")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc-section" }, [
                      _vm._v(
                        "File name, file type, extension and file storage configuration"
                      )
                    ]),
                    _vm._v(" "),
                    _c("b-row", [
                      _c("div", { staticClass: "col-12 mb-2" }, [
                        _c("div", [
                          _c("label", [_vm._v(" Type ")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "selections" },
                            _vm._l(_vm.fileTypeOptions, function(option) {
                              return _c(
                                "div",
                                {
                                  key: option.id,
                                  staticClass: "option",
                                  class: {
                                    selected:
                                      option.id ===
                                      _vm.data_action.generate_file.type,
                                    "error-input":
                                      _vm.$v.data_action.generate_file.type
                                        .$error
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.data_action.generate_file.type =
                                        option.id
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/file-" +
                                        option.id +
                                        ".svg"),
                                      alt: option.text
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(option.text))])
                                ]
                              )
                            })
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-7 mb-2 pr-1" },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.generate_file.file_name
                                    .$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Name ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Input File Name" },
                                model: {
                                  value:
                                    _vm.data_action.generate_file.file_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.generate_file,
                                      "file_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_action.generate_file.file_name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-5 mb-2 pl-1" },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.generate_file.extension
                                    .$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Extension ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Input Extension" },
                                model: {
                                  value:
                                    _vm.data_action.generate_file.extension,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.generate_file,
                                      "extension",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_action.generate_file.extension"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "company-drive-path" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c("label", [_vm._v(" Company Drive Path ")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: { placeholder: "Input Path" },
                                  model: {
                                    value: _vm.data_action.generate_file.path,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_action.generate_file,
                                        "path",
                                        $$v
                                      )
                                    },
                                    expression: "data_action.generate_file.path"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-search icon-search",
                              on: {
                                click: function($event) {
                                  _vm.openModalCompanyDrive(false)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-border mb-3" },
                  [
                    _c("p", { staticClass: "title-section" }, [_vm._v("Data")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc-section" }, [
                      _vm._v(
                        "Configuration of type, header, delimiter and content"
                      )
                    ]),
                    _vm._v(" "),
                    _c("b-row", [
                      _vm.data_action.generate_file.type !== "txt"
                        ? _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("label", [_vm._v(" Type ")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "selections" },
                                _vm._l(_vm.dataTypeOptions, function(option) {
                                  return _c(
                                    "div",
                                    {
                                      key: option.id,
                                      staticClass: "option",
                                      class: {
                                        selected:
                                          option.id ===
                                          _vm.data_action.generate_file
                                            .data_type,
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .data_type.$error
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.data_action.generate_file.data_type =
                                            option.id
                                        }
                                      }
                                    },
                                    [_c("p", [_vm._v(_vm._s(option.text))])]
                                  )
                                })
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "info-field" }, [
                                _vm._v("Type of source content")
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            _vm.data_action.generate_file.type !== "txt"
                              ? "col-7 pr-1"
                              : "col-12"
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.generate_file.header.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Header ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Input Header" },
                                model: {
                                  value: _vm.data_action.generate_file.header,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.generate_file,
                                      "header",
                                      $$v
                                    )
                                  },
                                  expression: "data_action.generate_file.header"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.data_action.generate_file.type !== "txt"
                        ? _c(
                            "div",
                            { staticClass: "col-5 pl-1" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.delimiterSelected
                                        .$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Delimiter ")]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.delimiterOptions,
                                      placeholder: "Select Delimiter"
                                    },
                                    model: {
                                      value: _vm.data_action.delimiterSelected,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action,
                                          "delimiterSelected",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.delimiterSelected"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 mt-2" },
                        [
                          _vm.data_action.delimiterSelected === "other"
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.generate_file.delimiter
                                        .$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Other Delimiter ")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      placeholder: "Input Other Delimiter"
                                    },
                                    model: {
                                      value:
                                        _vm.data_action.generate_file.delimiter,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action.generate_file,
                                          "delimiter",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.generate_file.delimiter"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.generate_file.data.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Content ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Input Data" },
                                model: {
                                  value: _vm.data_action.generate_file.data,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.generate_file,
                                      "data",
                                      $$v
                                    )
                                  },
                                  expression: "data_action.generate_file.data"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.data_action.generate_file.type === "csv"
                  ? _c(
                      "div",
                      { staticClass: "section-border mb-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("j-switch", {
                              model: {
                                value:
                                  _vm.data_action.generate_file.encryption
                                    .active,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.data_action.generate_file.encryption,
                                    "active",
                                    $$v
                                  )
                                },
                                expression:
                                  "data_action.generate_file.encryption.active"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.data_action.generate_file.encryption.active
                          ? _c("b-row", [
                              _c("div", { staticClass: "col-12 mb-1" }, [
                                _c("label", [_vm._v(" Algorithm ")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "selections" }, [
                                  _c(
                                    "div",
                                    { staticClass: "selected option" },
                                    [_c("p", [_vm._v("AES256")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "info-field" }, [
                                  _vm._v("Type of algorithm encryption")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 mb-1" }, [
                                _c("label", [_vm._v(" Cipher Mode ")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "selections" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option",
                                      class: {
                                        selected:
                                          _vm.data_action.generate_file
                                            .encryption.cipher_mode === "gcm",
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .encryption.cipher_mode.$error
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.data_action.generate_file.encryption.cipher_mode =
                                            "gcm"
                                        }
                                      }
                                    },
                                    [_c("p", [_vm._v("GCM")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option",
                                      class: {
                                        selected:
                                          _vm.data_action.generate_file
                                            .encryption.cipher_mode === "cbc",
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .encryption.cipher_mode.$error
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.data_action.generate_file.encryption.cipher_mode =
                                            "cbc"
                                        }
                                      }
                                    },
                                    [_c("p", [_vm._v("CBC")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "info-field" }, [
                                  _vm._v("Type of Cipher Mode Decryption")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 mb-1" }, [
                                _c("label", [_vm._v(" Output Text Format ")]),
                                _vm._v(" "),
                                _c("div", { staticClass: "selections" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option",
                                      class: {
                                        selected:
                                          _vm.data_action.generate_file
                                            .encryption.output_text_format ===
                                          "hex",
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .encryption.output_text_format
                                            .$error
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.data_action.generate_file.encryption.output_text_format =
                                            "hex"
                                        }
                                      }
                                    },
                                    [_c("p", [_vm._v("Hex")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "option",
                                      class: {
                                        selected:
                                          _vm.data_action.generate_file
                                            .encryption.output_text_format ===
                                          "base64",
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .encryption.output_text_format
                                            .$error
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.data_action.generate_file.encryption.output_text_format =
                                            "base64"
                                        }
                                      }
                                    },
                                    [_c("p", [_vm._v("Base 64")])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "info-field" }, [
                                  _vm._v("Type of Text Format")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 mb-1" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .encryption.initial_vector.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Initial Vector ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          placeholder: "Input Initial Vector"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.generate_file
                                              .encryption.initial_vector,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.generate_file
                                                .encryption,
                                              "initial_vector",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.generate_file.encryption.initial_vector"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.generate_file
                                            .encryption.secret_key.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Secret Key ")]),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "info-label-config" },
                                        [_vm._v("Must be 32 char")]
                                      ),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "max-length": 32,
                                          placeholder: "Input Secret Key"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.generate_file
                                              .encryption.secret_key,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.generate_file
                                                .encryption,
                                              "secret_key",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.generate_file.encryption.secret_key"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "file_transfer_ftp"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "section-border mb-3" },
                  [
                    _c("p", { staticClass: "title-section" }, [
                      _vm._v("General")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc-section" }, [
                      _vm._v(
                        "Choose an action to be used for this action and a connection to a third party."
                      )
                    ]),
                    _vm._v(" "),
                    _c("b-row", [
                      _c(
                        "div",
                        { staticClass: "col-12 mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              class: {
                                "error-input":
                                  _vm.$v.data_action.file_transfer_ftp.do.$error
                              }
                            },
                            [
                              _c("label", [_vm._v("Do")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.doOptionsFileTransfer,
                                  placeholder: "Select"
                                },
                                model: {
                                  value: _vm.data_action.file_transfer_ftp.do,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.file_transfer_ftp,
                                      "do",
                                      $$v
                                    )
                                  },
                                  expression: "data_action.file_transfer_ftp.do"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              class: {
                                "error-input":
                                  _vm.$v.data_action.file_transfer_ftp
                                    .third_party_connection.$error
                              }
                            },
                            [
                              _c("label", [_vm._v("Third Party Connection")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.listThirdParty,
                                  placeholder: "Select Third Party Connection",
                                  label: "label"
                                },
                                on: {
                                  select: _vm.onChangeThirdPartyConnection
                                },
                                model: {
                                  value:
                                    _vm.data_action.file_transfer_ftp
                                      .third_party_connection,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.file_transfer_ftp,
                                      "third_party_connection",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_action.file_transfer_ftp.third_party_connection"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do ===
                            "ftp_read_single_file" ||
                          _vm.data_action.file_transfer_ftp.do ===
                            "ftp_get_list_directory"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-2",
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.file_transfer_ftp
                                        .source_path.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v("FTP Source File")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      placeholder: "Type FTP Source File"
                                    },
                                    model: {
                                      value:
                                        _vm.data_action.file_transfer_ftp
                                          .source_path,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action.file_transfer_ftp,
                                          "source_path",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.file_transfer_ftp.source_path"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do ===
                          "ftp_download_single_file"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-2",
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.file_transfer_ftp
                                        .source_file.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v("FTP Source File")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      placeholder: "Input FTP Source File"
                                    },
                                    model: {
                                      value:
                                        _vm.data_action.file_transfer_ftp
                                          .source_file,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action.file_transfer_ftp,
                                          "source_file",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.file_transfer_ftp.source_file"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do === "ftp_upload"
                            ? _c(
                                "div",
                                { staticClass: "company-drive-path" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.file_transfer_ftp
                                            .source_file.$error
                                      }
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(" Company Drive Source File ")
                                      ]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          placeholder:
                                            "Input Company Drive Source File"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.file_transfer_ftp
                                              .source_file,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.file_transfer_ftp,
                                              "source_file",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.file_transfer_ftp.source_file"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-search icon-search",
                                    on: {
                                      click: function($event) {
                                        _vm.openModalCompanyDrive(true)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do ===
                            "ftp_move_single_file" ||
                          _vm.data_action.file_transfer_ftp.do ===
                            "ftp_delete_single_file"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-2",
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.file_transfer_ftp
                                        .ftp_source_file_path.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v("FTP Source File Path")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      placeholder: "Input FTP Source File Path"
                                    },
                                    model: {
                                      value:
                                        _vm.data_action.file_transfer_ftp
                                          .ftp_source_file_path,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action.file_transfer_ftp,
                                          "ftp_source_file_path",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.file_transfer_ftp.ftp_source_file_path"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do ===
                          "ftp_download_single_file"
                            ? _c(
                                "div",
                                { staticClass: "company-drive-path" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.file_transfer_ftp
                                            .destination_path.$error
                                      }
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(" Company Drive Path ")
                                      ]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          placeholder:
                                            "Input Company Drive Path"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.file_transfer_ftp
                                              .destination_path,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.file_transfer_ftp,
                                              "destination_path",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.file_transfer_ftp.destination_path"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-search icon-search",
                                    on: {
                                      click: function($event) {
                                        _vm.openModalCompanyDrive(false)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do === "ftp_upload"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-2",
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.file_transfer_ftp
                                        .destination_path.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v("FTP Path")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: { placeholder: "Input FTP Path" },
                                    model: {
                                      value:
                                        _vm.data_action.file_transfer_ftp
                                          .destination_path,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action.file_transfer_ftp,
                                          "destination_path",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.file_transfer_ftp.destination_path"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.data_action.file_transfer_ftp.do ===
                          "ftp_move_single_file"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-2",
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.file_transfer_ftp
                                        .ftp_destination_folder.$error
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v("FTP Destination Folder")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      placeholder:
                                        "Input FTP Destination Folder"
                                    },
                                    model: {
                                      value:
                                        _vm.data_action.file_transfer_ftp
                                          .ftp_destination_folder,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action.file_transfer_ftp,
                                          "ftp_destination_folder",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.file_transfer_ftp.ftp_destination_folder"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.data_action.file_transfer_ftp.do === "ftp_read_single_file"
                  ? _c(
                      "div",
                      { staticClass: "section-border mb-3" },
                      [
                        _c("p", { staticClass: "title-section" }, [
                          _vm._v("File Properties")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc-section" }, [
                          _vm._v(
                            "File name, file type, extension and file storage configuration."
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-row", [
                          _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "mb-2" }, [
                              _c("label", [_vm._v(" Type ")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "selections" },
                                _vm._l(_vm.fileTypeOptions, function(option) {
                                  return _c(
                                    "div",
                                    {
                                      key: option.id,
                                      staticClass: "option",
                                      class: {
                                        selected:
                                          option.id ===
                                          _vm.data_action.file_transfer_ftp
                                            .extension,
                                        "error-input":
                                          _vm.$v.data_action.file_transfer_ftp
                                            .extension.$error
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.data_action.file_transfer_ftp.extension =
                                            option.id
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/icon/file-" +
                                            option.id +
                                            ".svg"),
                                          alt: option.text
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(option.text))])
                                    ]
                                  )
                                })
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "info-field" }, [
                                _vm._v("Type of source content")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-6 pr-1" },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", [_vm._v(" Delimiter ")]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.delimiterOptions,
                                      placeholder: "Select Delimiter"
                                    },
                                    model: {
                                      value: _vm.data_action.delimiterSelected,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_action,
                                          "delimiterSelected",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_action.delimiterSelected"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.data_action.delimiterSelected === "other"
                            ? _c(
                                "div",
                                { staticClass: "col-6 pl-1" },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("label", [
                                        _vm._v(" Other Delimiter ")
                                      ]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          placeholder: "Input Other Delimiter"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.file_transfer_ftp
                                              .delimiter,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.file_transfer_ftp,
                                              "delimiter",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.file_transfer_ftp.delimiter"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.object === "compress_file"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "section-border mb-3" },
                  [
                    _c("b-row", [
                      _c(
                        "div",
                        { staticClass: "col-7 mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.compress_file.name.$error
                              }
                            },
                            [
                              _c("label", [_vm._v("Name")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Type File Name" },
                                model: {
                                  value: _vm.data_action.compress_file.name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.compress_file,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "data_action.compress_file.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-5 mb-2" },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_action.compress_file.compress_type
                                    .$error
                              }
                            },
                            [
                              _c("label", [_vm._v("Compression Format")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.compressTypeOptions,
                                  placeholder: "Select Format"
                                },
                                model: {
                                  value:
                                    _vm.data_action.compress_file.compress_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.compress_file,
                                      "compress_type",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_action.compress_file.compress_type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 mb-2" },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", [_vm._v("Set Password")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { placeholder: "Enter Password" },
                                model: {
                                  value: _vm.data_action.compress_file.password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_action.compress_file,
                                      "password",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_action.compress_file.password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "company-drive-path" },
                          [
                            _c(
                              "b-form-group",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.data_action.compress_file
                                      .destination_folder.$error
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(" Company Drive Destination Folder ")
                                ]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: {
                                    placeholder: "Input Destination Folder Path"
                                  },
                                  model: {
                                    value:
                                      _vm.data_action.compress_file
                                        .destination_folder,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_action.compress_file,
                                        "destination_folder",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "data_action.compress_file.destination_folder"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-search icon-search",
                              on: {
                                click: function($event) {
                                  _vm.openModalCompanyDrive(false)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-border mb-3" },
                  [
                    _c("p", { staticClass: "title-section" }, [_vm._v("Data")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc-section" }, [
                      _vm._v("Configuration source of file to compression")
                    ]),
                    _vm._v(" "),
                    _c("b-row", [
                      _c("div", { staticClass: "col-12 mb-3" }, [
                        _c("label", [_vm._v(" Type ")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "selections" },
                          _vm._l(_vm.typeFileCompressOptions, function(option) {
                            return _c(
                              "div",
                              {
                                key: option.id,
                                staticClass: "option",
                                class: {
                                  selected:
                                    option.id ===
                                    _vm.data_action.compress_file.do,
                                  "error-input":
                                    _vm.$v.data_action.compress_file.do.$error
                                },
                                on: {
                                  click: function($event) {
                                    _vm.data_action.compress_file.do = option.id
                                  }
                                }
                              },
                              [_c("p", [_vm._v(_vm._s(option.text))])]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "info-field" }, [
                          _vm._v("Type of source content")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _vm.data_action.compress_file.do === "base64" ||
                          _vm.data_action.compress_file.do === "multiple_url"
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.data_action.compress_file
                                        .dataBase64.$error ||
                                      _vm.$v.data_action.compress_file
                                        .dataPublicUrl.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Content ")]),
                                  _vm._v(" "),
                                  _vm.data_action.compress_file.do === "base64"
                                    ? _c("j-textarea", {
                                        attrs: {
                                          placeholder: "Fill Base64 format"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.compress_file
                                              .dataBase64,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.compress_file,
                                              "dataBase64",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.compress_file.dataBase64"
                                        }
                                      })
                                    : _vm.data_action.compress_file.do ===
                                      "multiple_url"
                                    ? _c("j-textarea", {
                                        attrs: {
                                          placeholder:
                                            "Fill array Public URL can Officeless Access"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.compress_file
                                              .dataPublicUrl,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.compress_file,
                                              "dataPublicUrl",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.compress_file.dataPublicUrl"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm.data_action.compress_file.do ===
                              "company_drive"
                            ? _c(
                                "div",
                                { staticClass: "company-drive-path" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_action.compress_file
                                            .dataCompanyDrive.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Content ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          placeholder:
                                            "Fill array of File Path Company Drive"
                                        },
                                        model: {
                                          value:
                                            _vm.data_action.compress_file
                                              .dataCompanyDrive,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data_action.compress_file,
                                              "dataCompanyDrive",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "data_action.compress_file.dataCompanyDrive"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-search icon-search",
                                    on: {
                                      click: function($event) {
                                        _vm.openModalCompanyDrive(true, true)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.do === "find_record" ||
          _vm.data_action.do === "find_records" ||
          _vm.data_action.do === "create_record" ||
          _vm.data_action.do === "create_records" ||
          _vm.data_action.do === "delete_record" ||
          _vm.data_action.do === "update_record" ||
          _vm.data_action.object === "call_webhook" ||
          _vm.data_action.object === "data_connectivity" ||
          _vm.data_action.object === "function" ||
          _vm.data_action.object === "joana" ||
          _vm.data_action.object === "generate_file" ||
          _vm.data_action.object === "file_transfer_ftp" ||
          _vm.data_action.object === "compress_file"
            ? _c("div", { staticClass: "section-border mt-3 mb-4" }, [
                _c("p", { staticClass: "title-section" }, [
                  _vm._v("Configuration")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "desc-section" }, [
                  _vm._v("Additional Action block feature")
                ]),
                _vm._v(" "),
                _vm.data_action.do === "find_record" ||
                _vm.data_action.do === "find_records" ||
                _vm.data_action.do === "create_record" ||
                _vm.data_action.do === "create_records" ||
                _vm.data_action.do === "delete_record" ||
                _vm.data_action.do === "update_record" ||
                _vm.data_action.object === "call_webhook" ||
                _vm.data_action.object === "data_connectivity" ||
                _vm.data_action.object === "function" ||
                _vm.data_action.object === "joana" ||
                _vm.data_action.object === "generate_file" ||
                _vm.data_action.object === "file_transfer_ftp" ||
                _vm.data_action.object === "compress_file"
                  ? _c(
                      "div",
                      { staticClass: "config-toggle" },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("j-switch", {
                          model: {
                            value: _vm.data_action.is_disable_log,
                            callback: function($$v) {
                              _vm.$set(_vm.data_action, "is_disable_log", $$v)
                            },
                            expression: "data_action.is_disable_log"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data_action.do === "find_record" ||
                _vm.data_action.do === "find_records" ||
                _vm.data_action.do === "create_record" ||
                _vm.data_action.do === "delete_record" ||
                _vm.data_action.do === "update_record" ||
                _vm.data_action.object === "call_webhook" ||
                _vm.data_action.object === "data_connectivity" ||
                _vm.data_action.object === "function" ||
                _vm.data_action.object === "generate_file" ||
                _vm.data_action.object === "file_transfer_ftp" ||
                _vm.data_action.object === "compress_file"
                  ? _c(
                      "div",
                      { staticClass: "config-toggle" },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("j-switch", {
                          model: {
                            value: _vm.data_action.is_async,
                            callback: function($$v) {
                              _vm.$set(_vm.data_action, "is_async", $$v)
                            },
                            expression: "data_action.is_async"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data_action.object === "form" &&
                (_vm.data_action.do === "create_record" ||
                  _vm.data_action.do === "create_records")
                  ? _c(
                      "div",
                      { staticClass: "config-toggle" },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("j-switch", {
                          model: {
                            value: _vm.data_action.is_disable_audit_trail,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.data_action,
                                "is_disable_audit_trail",
                                $$v
                              )
                            },
                            expression: "data_action.is_disable_audit_trail"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.data_action.object === "file_transfer_ftp" &&
                _vm.data_action.file_transfer_ftp.do ===
                  "ftp_delete_single_file"
                  ? _c(
                      "div",
                      { staticClass: "config-toggle" },
                      [
                        _vm._m(8),
                        _vm._v(" "),
                        _c("j-switch", {
                          model: {
                            value:
                              _vm.data_action.file_transfer_ftp
                                .backup_to_company_drive,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.data_action.file_transfer_ftp,
                                "backup_to_company_drive",
                                $$v
                              )
                            },
                            expression:
                              "data_action.file_transfer_ftp.backup_to_company_drive"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.data_action.do === "find_record" ||
          _vm.data_action.do === "find_records" ||
          _vm.data_action.do === "create_record" ||
          _vm.data_action.do === "create_records" ||
          _vm.data_action.do === "delete_record" ||
          _vm.data_action.do === "update_record" ||
          _vm.data_action.object === "call_webhook" ||
          _vm.data_action.object === "function" ||
          _vm.data_action.object === "joana" ||
          _vm.data_action.object === "send_notification" ||
          _vm.data_action.object === "data_connectivity" ||
          _vm.data_action.object === "generate_file" ||
          _vm.data_action.object === "file_transfer_ftp" ||
          _vm.data_action.object === "compress_file"
            ? _c(
                "div",
                [
                  _c("hr"),
                  _vm._v(" "),
                  _vm.data_action.do === "find_record" ||
                  _vm.data_action.do === "find_records" ||
                  _vm.data_action.do === "create_record" ||
                  _vm.data_action.do === "create_records" ||
                  _vm.data_action.do === "delete_record" ||
                  _vm.data_action.do === "update_record" ||
                  _vm.data_action.object === "call_webhook" ||
                  _vm.data_action.object === "function" ||
                  _vm.data_action.object === "joana" ||
                  _vm.data_action.object === "generate_file" ||
                  _vm.data_action.object === "file_transfer_ftp" ||
                  _vm.data_action.object === "compress_file"
                    ? _c("span", { staticClass: "title-automation" }, [
                        _vm._v("\n        Container\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_action.object === "send_notification" ||
                  _vm.data_action.object === "data_connectivity"
                    ? _c("span", { staticClass: "title-automation" }, [
                        _vm._v("\n        Container Variable\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_action.variable_name.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Variable Name ")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          "error-required":
                            _vm.$v.data_action.variable_name.$error,
                          "max-length": 255,
                          placeholder: "Variable Name"
                        },
                        model: {
                          value: _vm.$v.data_action.variable_name.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.data_action.variable_name,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.data_action.variable_name.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.onProperties,
              expression: "!onProperties"
            }
          ]
        },
        [
          _vm.dataEdit && _vm.showContainer && _vm.objectType
            ? _c(
                "b-row",
                { staticClass: "m__t--10" },
                [
                  _c("b-col", { staticClass: "p__r--1", attrs: { md: "2" } }, [
                    _vm.objectType === "form"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/data_manager.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "notif"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/notif.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "connectivity"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/connectivity.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "webhook"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/api.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "function"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/function.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "job" ||
                    _vm.objectType === "dedicated_job"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/job.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "joana"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/joana.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "generate_file"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/generate_file_gray.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "file_transfer_ftp"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/file_transfer_gray.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.objectType === "compress_file"
                      ? _c("img", {
                          staticClass: "m__t--5",
                          attrs: {
                            src: require("@/assets/automation/compress_file_gray.svg"),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.objectType === "form"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.data_action.form
                                      ? _vm.data_action.form.name
                                      : ""
                                  ) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.eventLabel) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "notif"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.dataEdit.type === "send_email"
                                      ? "Email"
                                      : "Push Notification"
                                  ) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [_vm._v("\n          Send Notification\n        ")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "connectivity"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.data_action.connection
                                      ? _vm.data_action.connection
                                          .connection_name
                                      : ""
                                  ) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.data_action.do_jdc === "exec_record"
                                      ? "Execution"
                                      : "Fetch"
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "webhook"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("\n          Hit External API\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.data_action.url) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "function"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("\n          Hit Function\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.data_action.function_name) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "job"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("\n          Job\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.data_action.job_name) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "dedicated_job"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("\n          Dedicated Job\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.data_action.dedicated_job_name) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "joana"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.data_action.joana.dataset
                                      ? _vm.data_action.joana.dataset.name
                                      : ""
                                  ) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.eventLabelJoana) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "generate_file"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("Generate File")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.dataEdit.type === "generate_file_csv"
                                      ? "Generate csv"
                                      : "Generate txt"
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "file_transfer_ftp"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("File Transfer")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.labelFileTransfer) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.objectType === "compress_file"
                    ? _c(
                        "b-col",
                        { staticClass: "p__l--1", attrs: { md: "10" } },
                        [
                          _c(
                            "div",
                            { staticClass: "trigger__label-form m__l--10" },
                            [_vm._v("File Compression")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trigger__label-event ellipsis m__l--10"
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.labelCompressFile) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataEdit &&
          _vm.showContainer &&
          _vm.objectType !== "job" && _vm.objectType !== "dedicated_job"
            ? _c(
                "div",
                { staticClass: "trigger__label-variable ellipsis m__t--10" },
                [
                  _c("img", {
                    staticClass: "m__r--10",
                    attrs: {
                      src: require("@/assets/automation/variable.png"),
                      width: "20",
                      height: "20"
                    }
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.dataEdit.container_variable) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.onProperties
        ? _c(
            "b-modal",
            {
              ref: "listSavedQueryModal",
              staticClass:
                "mod-form modal-add-record-data dataset-page-query-container",
              attrs: {
                centered: "",
                "no-close-on-esc": "",
                "no-close-on-backdrop": ""
              }
            },
            [
              _c("div", { staticClass: "label-create-form-data" }, [
                _vm._v("OPEN SAVED QUERY")
              ]),
              _vm._v(" "),
              _vm.listQuerySaved.length > 0
                ? _c(
                    "div",
                    { staticClass: "container-list-query-saved" },
                    _vm._l(_vm.listQuerySaved, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "list-query",
                          class: {
                            "m__t--10": index > 0,
                            "list-query-active":
                              item.id ===
                              (_vm.querySelected ? _vm.querySelected.id : "")
                          },
                          on: {
                            click: function($event) {
                              _vm.querySelected = item
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/icon/query/radio-" +
                                (item.id ===
                                (_vm.querySelected ? _vm.querySelected.id : "")
                                  ? "on"
                                  : "off") +
                                ".svg"),
                              width: "20"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "m__l--10" }, [
                            _c("div", { staticClass: "label-query" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.query_type,
                                      expression: "item.query_type"
                                    }
                                  ],
                                  staticClass: "content-type-query"
                                },
                                [_vm._v(_vm._s(item.query_type))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "id-query" }, [
                                _vm._v("#" + _vm._s(item.id))
                              ])
                            ])
                          ])
                        ]
                      )
                    })
                  )
                : _c("div", [_vm._v("No data option")]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "float-to-right" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn gray m__r--5",
                            on: { click: _vm.closeModalListSaved }
                          },
                          [_vm._v("\n            Close\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn blue",
                            attrs: { disabled: !_vm.querySelected },
                            on: { click: _vm.openQuerySelected }
                          },
                          [_vm._v("\n            Open\n          ")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.onProperties && _vm.isOpenModalCondition
        ? _c("modal-condition-action-block", {
            ref: "modalCondition",
            attrs: {
              "list-field": _vm.list_field,
              data: _vm.dataItemCondition,
              columns: _vm.getDataColumnsByObject,
              conditions: _vm.data_action.conditions,
              type: _vm.data_action.object
            },
            on: {
              submit: _vm.submitModalCondition,
              close: function($event) {
                _vm.toggleModalCondition(false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onProperties && _vm.isOpenModalExample
        ? _c("modal-example-action-block", {
            ref: "modalExample",
            attrs: { columns: _vm.dataColumnDataset },
            on: {
              close: function($event) {
                _vm.toggleModalExample(false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalCompanyDrive
        ? _c("modal-company-drive", {
            attrs: { "is-multiple": _vm.multipleSourceFile },
            on: { "close-popup": _vm.handleCloseModalCompanyDrive }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalFtp
        ? _c("modal-ftp", {
            attrs: { "third-party": _vm.detailThirdParty },
            on: { "close-popup": _vm.handleCloseModalFtp }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-automation" }, [_vm._v("Conditions")]),
      _vm._v(" "),
      _c("small", [_vm._v('"Where"')])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Information")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n            Object Job will always be asynchronous\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Information")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n            Object Job will always be asynchronous\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Information")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n              “limit” on query will have an impact on query performance, so please combine\n              between limit and offset.\n              (If you don’t use limit, the query will automatically run with limit 1000)\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "title-section" }, [_vm._v("Encryption")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-section mb-1" }, [
        _vm._v(
          "\n              Encryption in CSV generators refers to the process of encoding or scrambling the data within a CSV (Comma-Separated Values)\n              file to protect it from unauthorized access or viewing. This security measure is crucial in situations where sensitive or confidential\n              information is stored in CSV files, such as financial records, personal information, or proprietary data.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [
        _vm._v("Disable Run History")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n            To improve performance, the result of the block will be disabled in the run history. Container variables can still be used to store block execution results.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [_vm._v("Asynchronous")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n            Processing Block that allows  to execute tasks simultaneously without having to wait for previous tasks to complete first.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [
        _vm._v("Disable Audit Trail")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n            Activity logs can be disabled based on business process requirements or security needs.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [
        _vm._v("Backup to company drive")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n            Feature for backing up files that will be deleted on the FTP server. File will be store on company drive folder “Deleted File FTP”\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d1594d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1594d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPBlockAction.vue
// module id = null
// module chunks = 